import { render, staticRenderFns } from "./FrameInfoReview.vue?vue&type=template&id=7a42ce86"
import script from "./FrameInfoReview.vue?vue&type=script&lang=js"
export * from "./FrameInfoReview.vue?vue&type=script&lang=js"
import style0 from "./FrameInfoReview.vue?vue&type=style&index=0&id=7a42ce86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports